export default {
  title: 'Pubblico di test',
  columns: {
    id: 'Id',
    phone_number: 'Numero di telefono',
  },
  filters: {
    search: {
      placeholder: 'Cerca',
    },
  },
  buttons: {
    send_test: 'Invia test',
  },
  feedback: {
    success: 'Inviato con successo',
    error: 'Invio fallito',
  },
};
